var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { TableSpinner } from '../TableSpinner';
import Caption from './Caption';
import Header from './Header';
import Footer from './Footer';
import TableRow from './TableRow';
import { get } from '../..';
import { getBoxShadow } from '../shared';
var StyledTable = styled.table(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: ", ";\n  border: 1px solid ", ";\n\n  ", "\n\n  ", "\n"], ["\n  font-family: ", ";\n  border: 1px solid ", ";\n\n  ", "\n\n  ", "\n"])), get.fonts('regular'), get.colors('grey-80'), function (_a) {
    var container = _a.container;
    return container ? getBoxShadow() : css(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
}, function (_a) {
    var fullWidth = _a.fullWidth;
    if (fullWidth)
        return 'width: 100%';
    return '';
});
var StyledThead = styled.thead(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n"])), get.colors('yacht-rock'), get.colors('grey-80'));
var StyledTbody = styled.tbody(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow: visible;\n"], ["\n  overflow: visible;\n"])));
var StyledTfoot = styled.tfoot(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), get.colors('white'));
var StyledTRow = styled.tr(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), get.colors('white'));
var Spinner = function (_a) {
    var headerGroups = _a.headerGroups;
    return (React.createElement(StyledTRow, null,
        React.createElement("td", { colSpan: headerGroups[0].headers.length },
            React.createElement(TableSpinner, null))));
};
var LgUpTableRefForwarding = function (_a, ref) {
    var tableInstance = _a.tableInstance, className = _a.className, container = _a.container, captionText = _a.captionText, _b = _a.isCaptionVisible, isCaptionVisible = _b === void 0 ? false : _b, // hide caption from visual users, but it is still readable by screen readers
    fullWidth = _a.fullWidth, _c = _a.withFooter, withFooter = _c === void 0 ? false : _c, isLoading = _a.isLoading, rowProps = __rest(_a, ["tableInstance", "className", "container", "captionText", "isCaptionVisible", "fullWidth", "withFooter", "isLoading"]);
    var getTableProps = tableInstance.getTableProps, getTableBodyProps = tableInstance.getTableBodyProps, headerGroups = tableInstance.headerGroups, footerGroups = tableInstance.footerGroups, preExpandedRows = tableInstance.preExpandedRows, prepareRow = tableInstance.prepareRow;
    return (React.createElement(StyledTable, __assign({}, getTableProps(), { className: className, container: container, fullWidth: fullWidth, ref: ref, tabIndex: -1 }),
        React.createElement(Caption, __assign({}, { captionText: captionText, isCaptionVisible: isCaptionVisible })),
        React.createElement(StyledThead, null, headerGroups.map(function (headerGroup) { return (React.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (React.createElement(Header, { key: column.id, column: column })); }))); })),
        isLoading ? (React.createElement(Spinner, { headerGroups: headerGroups })) : (React.createElement(StyledTbody, __assign({}, getTableBodyProps()), preExpandedRows.map(function (row, index) {
            prepareRow(row);
            return (React.createElement(TableRow, __assign({ key: row.id }, __assign({ row: row, index: index, tableInstance: tableInstance }, rowProps))));
        }))),
        withFooter && (React.createElement(StyledTfoot, null, footerGroups.map(function (group) { return (React.createElement("tr", __assign({}, group.getFooterGroupProps()), group.headers.map(function (column) { return (React.createElement(Footer, { key: column.id, column: column })); }))); })))));
};
var LgUpTable = React.forwardRef(LgUpTableRefForwarding);
export default LgUpTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map